import type { MigrationStrategies } from "$global-providers/rxdb-provider/migration-strategies/_types/migration-strategies";
import { v4 } from "uuid";

export const PATIENT_CLINICAL_RESOURCE_MIGRATION_STRATEGIES: MigrationStrategies =
  {
    1: (oldDoc) => oldDoc,
    2: (oldDoc) => {
      const { externalCoding, ...rest } = oldDoc;
      const newDoc = {
        ...rest,
        fhirResource: {
          ...oldDoc.fhirResource,
          externalCoding,
          diagnosticReport: null,
        },
      };
      return newDoc;
    },
    3: (oldDoc) => oldDoc,
    4: (oldDoc) => {
      const newDoc = {
        ...oldDoc,
        fhirResource: {
          ...oldDoc.fhirResource,
          externalCoding: {
            ...oldDoc.fhirResource.externalCoding,
            elephantInternal: null,
          },
        },
      };
      return newDoc;
    },
    5: (oldDoc) => {
      const newDoc = {
        ...oldDoc,
        compositeKey: oldDoc.id,
        id: v4(),
      };
      return newDoc;
    },
    6: (oldDoc) => {
      // Copy compositeKey back to id and remove compositeKey field
      // This reverses the migration from version 5
      const { compositeKey, ...rest } = oldDoc;
      const newDoc = {
        ...rest,
        id: compositeKey,
      };
      return newDoc;
    },
    7: (oldDoc) => {
      // Fix documents that may have undefined/invalid IDs from v6 migration
      // If id is undefined or invalid, the document is corrupted and should be skipped
      // RxDB will handle cleanup of invalid documents

      // If compositeKey still exists (shouldn't happen, but defensive)
      if ("compositeKey" in oldDoc) {
        const { compositeKey, ...rest } = oldDoc;
        return {
          ...rest,
          id: compositeKey || oldDoc.id,
        };
      }

      // Document is already in correct format
      return oldDoc;
    },
  };
